const enum DropdownVariant {
  default = 'default',
  iconLeading = 'iconLeading',
  avatarLeading = 'avatarLeading',
  dotLeading = 'dotLeading',
  search = 'search',
  tags = 'tags',
}

export default DropdownVariant
